export const API_URL = "https://coitbbe-d4bxcvd3h3g6fqca.eastus-01.azurewebsites.net"
//export const API_URL = "http://localhost:3002"
